import { render, staticRenderFns } from "./PagamentoAdministrativoCanceladoRead.vue?vue&type=template&id=79c0d65a&"
import script from "./PagamentoAdministrativoCanceladoRead.vue?vue&type=script&lang=js&"
export * from "./PagamentoAdministrativoCanceladoRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports